<template>
  <table>
    <tr v-for="row in rows">
      <th class="header">
        {{ row.label }}
      </th>
      <td class="content">
        <div class="info_content">
          <slot :name="'row-' + row.id">
            {{ row.label }}
          </slot>
        </div>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  props: [
      'rows',
  ],
}
</script>

<style lang="scss">
</style>
